import { examAssignmentService } from '../../services/examAssignment.service';
import { notificationActions } from './notification.actions';

const examAssignmentConstants = {
  ASSIGN_EXAM_REQUEST: 'EXAM_ASSIGNMENT_ASSIGN_REQUEST',
  ASSIGN_EXAM_SUCCESS: 'EXAM_ASSIGNMENT_ASSIGN_SUCCESS',
  ASSIGN_EXAM_FAILURE: 'EXAM_ASSIGNMENT_ASSIGN_FAILURE',

  GET_STUDENT_EXAMS_REQUEST: 'EXAM_ASSIGNMENT_GET_STUDENT_EXAMS_REQUEST',
  GET_STUDENT_EXAMS_SUCCESS: 'EXAM_ASSIGNMENT_GET_STUDENT_EXAMS_SUCCESS',
  GET_STUDENT_EXAMS_FAILURE: 'EXAM_ASSIGNMENT_GET_STUDENT_EXAMS_FAILURE',

  GET_EXAM_STUDENTS_REQUEST: 'EXAM_ASSIGNMENT_GET_EXAM_STUDENTS_REQUEST',
  GET_EXAM_STUDENTS_SUCCESS: 'EXAM_ASSIGNMENT_GET_EXAM_STUDENTS_SUCCESS',
  GET_EXAM_STUDENTS_FAILURE: 'EXAM_ASSIGNMENT_GET_EXAM_STUDENTS_FAILURE',

  UPDATE_STATUS_REQUEST: 'EXAM_ASSIGNMENT_UPDATE_STATUS_REQUEST',
  UPDATE_STATUS_SUCCESS: 'EXAM_ASSIGNMENT_UPDATE_STATUS_SUCCESS',
  UPDATE_STATUS_FAILURE: 'EXAM_ASSIGNMENT_UPDATE_STATUS_FAILURE',

  DELETE_REQUEST: 'EXAM_ASSIGNMENT_DELETE_REQUEST',
  DELETE_SUCCESS: 'EXAM_ASSIGNMENT_DELETE_SUCCESS',
  DELETE_FAILURE: 'EXAM_ASSIGNMENT_DELETE_FAILURE',
};

const assignExamToStudents = (exam_id: number, student_ids: number[]) => {
  return (dispatch: any) => {
    dispatch(request());

    examAssignmentService.assignExamToStudents(exam_id, student_ids).then(
      (data: any) => {
        dispatch(success(data));
        dispatch(notificationActions.addNotification('Exam assigned successfully!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request() {
    return { type: examAssignmentConstants.ASSIGN_EXAM_REQUEST };
  }
  function success(data: any) {
    return { type: examAssignmentConstants.ASSIGN_EXAM_SUCCESS, payload: data };
  }
  function failure(error: any) {
    return { type: examAssignmentConstants.ASSIGN_EXAM_FAILURE, payload: error };
  }
};

const getStudentAssignedExams = (student_id: number) => {
  return (dispatch: any) => {
    dispatch(request());

    examAssignmentService.getStudentAssignedExams(student_id).then(
      (data: any) => {
        console.log('getStudentAssignedExams success:', data);
        dispatch(success(data));
      },
      (error: any) => {
        console.error('getStudentAssignedExams error:', error);
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request() {
    return { type: examAssignmentConstants.GET_STUDENT_EXAMS_REQUEST };
  }
  function success(data: any) {
    return { type: examAssignmentConstants.GET_STUDENT_EXAMS_SUCCESS, payload: data };
  }
  function failure(error: any) {
    return { type: examAssignmentConstants.GET_STUDENT_EXAMS_FAILURE, payload: error };
  }
};

const getExamAssignedStudents = (exam_id: number) => {
  return (dispatch: any) => {
    dispatch(request());

    examAssignmentService.getExamAssignedStudents(exam_id).then(
      (data: any) => {
        dispatch(success(data));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request() {
    return { type: examAssignmentConstants.GET_EXAM_STUDENTS_REQUEST };
  }
  function success(data: any) {
    return { type: examAssignmentConstants.GET_EXAM_STUDENTS_SUCCESS, payload: data };
  }
  function failure(error: any) {
    return { type: examAssignmentConstants.GET_EXAM_STUDENTS_FAILURE, payload: error };
  }
};

const updateAssignmentStatus = (assignment_id: number, status: string) => {
  return (dispatch: any) => {
    dispatch(request());

    examAssignmentService.updateAssignmentStatus(assignment_id, { status }).then(
      (data: any) => {
        dispatch(success(data));
        dispatch(notificationActions.addNotification('Status updated!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request() {
    return { type: examAssignmentConstants.UPDATE_STATUS_REQUEST };
  }
  function success(data: any) {
    return { type: examAssignmentConstants.UPDATE_STATUS_SUCCESS, payload: data };
  }
  function failure(error: any) {
    return { type: examAssignmentConstants.UPDATE_STATUS_FAILURE, payload: error };
  }
};

const deleteAssignment = (assignment_id: number) => {
  return (dispatch: any) => {
    dispatch(request());

    examAssignmentService.deleteAssignment(assignment_id).then(
      () => {
        dispatch(success());
        dispatch(notificationActions.addNotification('Assignment deleted!', 'SUCCESS'));
      },
      (error: any) => {
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification(error.toString(), 'DANGER'));
      }
    );
  };

  function request() {
    return { type: examAssignmentConstants.DELETE_REQUEST };
  }
  function success() {
    return { type: examAssignmentConstants.DELETE_SUCCESS };
  }
  function failure(error: any) {
    return { type: examAssignmentConstants.DELETE_FAILURE, payload: error };
  }
};

export const examAssignmentActions = {
  assignExamToStudents,
  getStudentAssignedExams,
  getExamAssignedStudents,
  updateAssignmentStatus,
  deleteAssignment,
};

export { examAssignmentConstants };
